import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserField, UserFieldsStore } from '@fry/lib/user-fields';


@Injectable()
export class UserFieldEditResolver  {

    constructor(private userfields: UserFieldsStore) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<UserField> {
        const id = route.paramMap.get('id');
        return this.userfields.getForEdit(id);
    }
}
